import { tag_category_type } from "@acme/db";

type OutfitItemConfig = {
  required: boolean;
  category: tag_category_type;
};

// Define the configuration for each outfit item
export const OUTFIT_MODIFIER_RULES: Record<string, OutfitItemConfig> = {
  shirt: {
    required: true,
    category: "shirt",
  },
  jacket: {
    required: false,
    category: "jacket",
  },
};
